export default __webpack_public_path__ + "media/images/feather_icon-70da84a8a67f1c53bfe24baabe8eff46.png";